import { IAnalyticsResponse } from '@adminPortal/_common/_interfaces/IAnalytics';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { StatisticsActions } from './statistics.actions';

export const statisticsFeatureKey = 'statistics';

export interface StatisticsState {
  statistics: IAnalyticsResponse | null;
  loading: boolean;
  error: any;
}

export const initialState: StatisticsState = {
  statistics: null,
  loading: false,
  error: null,
};

export const statisticsFeature = createFeature({
  name: statisticsFeatureKey,
  reducer: createReducer(
    initialState,
    on(StatisticsActions.loadStatistics, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(StatisticsActions.loadStatisticsSuccess, (state, { statistics }) => ({
      ...state,
      statistics,
      loading: false,
      error: null,
    })),
    on(StatisticsActions.loadStatisticsFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }))
  ),
  extraSelectors: ({ selectStatisticsState }) => ({
    selectStatistics: createSelector(selectStatisticsState, (state) => state.statistics),
    selectStatisticsLoading: createSelector(selectStatisticsState, (state) => state.loading),
  }),
});
